/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Party_Label_One_ChildInputs */

const en_party_label_one_child = /** @type {(inputs: Party_Label_One_ChildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 child`)
};

/**
* | output |
* | --- |
* | "1 child" |
*
* @param {Party_Label_One_ChildInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const party_label_one_child = /** @type {((inputs?: Party_Label_One_ChildInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Party_Label_One_ChildInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_party_label_one_child(inputs)
});